import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class PremiumPokesService extends BasicService {
    getSettings() {
        return this.checkError(axios.get(this.getApiUrl(true) + 'premiumPokes/getSettings', { headers: authHeader() }));
    }

    addChannel(cid, channelGroups, msgContent, pokeContent, type) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'premiumPokes/addChannel',
            { cid: cid, channelGroups: channelGroups, msgContent: msgContent, pokeContent: pokeContent, type: type }, { headers: authHeader() }));
    }

    delChannel(cid) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'premiumPokes/delChannel', { cid: cid }, { headers: authHeader() }));
    }

    getAllChannels() {
        return this.checkError(axios.get(this.getApiUrl(true) + 'premiumPokes/getAllChannels', { headers: authHeader() }));
    }

    getAllChannelGroups() {
        return this.checkError(axios.get(this.getApiUrl(true) + 'premiumPokes/getAllChannelGroups', { headers: authHeader() }));
    }
}

export default new PremiumPokesService();